"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _getDispatch(globalStateManager) {
    return globalStateManager.dispatchers;
}
exports.default = _getDispatch;
;
